<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (chatDetailReady$ | async) {
  <app-screen-shell
    [contentClass]="'container chat-detail-screen'"
    [title]="chat.id ? chat.displayName : ('chat.new' | translate)"
    (back)="goBack()">
    <form class="row" autocomplete="off" (ngSubmit)="saveChat()" #chatForm="ngForm">
      <div class="form-group col-12 col-md-6 mx-auto">
        <section class="chat-friends-picker mb-4">
          <div class="chat-friends-search">
            <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
            <input [(ngModel)]="playerFilter" class="form-control"
              (ngModelChange)="onPlayerFilterChange()"
              [placeholder]="'validation.searchPlayer' | translate"
              id="chatPlayerSearch" autocomplete="off" name="playerFilter">
          </div>
          <div class="chat-selected-section">
            @if (chat.players && chat.players.length > 0) {
              <div class="chat-selected-players">
                @for (player of chat.players; track player) {
                  <span class="chat-selected-chip">
                    {{getPlayerDisplayName(player)}}
                    @if (chat.viewedByManager && player.id !== chat.contact.id) {
                      <button type="button" (click)="removePlayerFromChat(player)">
                        <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
                        <span class="sr-only">{{ 'chat.removePlayer' | translate }}</span>
                      </button>
                    }
                  </span>
                }
              </div>
            }
            <div appActionBar class="chat-detail-actions">
              <button class="btn btn-secondary" type="button" [disabled]="chatSaving" (click)="cancelChatDetailsChange()">{{ 'common.cancel' | translate }}</button>
              @if (chat.viewedByManager && chat.id && chat.entityType === chatEntityType.PLAYER && chat.priority >= 10) {
                <button
                  class="btn btn-outline-danger" type="button" [disabled]="chatSaving"
                  (click)="showDeleteDialog = !showDeleteDialog">
                  <i [class]="'common.delete' | nogoshIcon" aria-hidden="true"></i>
                  <span>{{ 'common.delete' | translate }}</span>
                </button>
              }

              <button appSaveAction [saved]="chatSaved" [saving]="chatSaving" class="btn btn-primary" type="submit" [disabled]="chatSaving || !canSaveChat()">
                <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
                <span>{{ 'common.save' | translate }}</span>
              </button>
            </div>
            <app-dialog [(visible)]="showDeleteDialog" [closable]="false" class="app-dialog--confirm">
              <div class="modal-header">
                <h5 class="mb-0">{{ 'chat.deleteTitle' | translate }}</h5>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm px-3" (click)="showDeleteDialog = false">{{ 'common.no' | translate }}</button>
                <button type="button" class="btn btn-primary btn-sm px-3" (click)="removeChat(); showDeleteDialog = false">{{ 'common.yes' | translate }}</button>
              </div>
            </app-dialog>
          </div>
          <div class="chat-friends-list">
            @if (loadingPlayers) {
              <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
            }
            @if (!loadingPlayers && visiblePlayerCandidates.length === 0) {
              <div class="chat-friends-state">{{ 'events.invitePlayersNoResults' | translate }}</div>
            }
            @for (player of visiblePlayerCandidates; track player.id) {
              <button type="button" class="chat-friend-row" (click)="addPlayerToChat(player)">
                <div class="chat-friend-avatar" [style.backgroundImage]="player.avatar ? 'url(' + player.avatar + ')' : null">
                  @if (!player.avatar) {
                    <span>{{getPlayerInitials(player)}}</span>
                  }
                </div>
                <div class="chat-friend-copy">
                  <strong>{{getPlayerDisplayName(player)}}</strong>
                  @if (player.name && player.name !== player.nickName) {
                    <span>{{player.name}}</span>
                  }
                </div>
                <span class="chat-friend-add"><i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i></span>
              </button>
            }
          </div>
        </section>
      </div><!-- .form-group -->
    </form>
  </app-screen-shell>
}
